define('frontend-common-components/gettingStartedPanel/js/models/actionModel',[
    'backbone'
],
function (Backbone) {
    'use strict';
    return Backbone.Model.extend({
        initialize: function() {
            
        },
        
        defaults: {
            'enabled': false,
            'completed': false
        }
    });
});

/*
var model = new ActionModel({ title: 'myTitle' });
 */;
